export default {
  type: "Feature",
  properties: {
    name: "Чингис",
    location: [47.30823, 110.6245],
  },
  geometry: {
    type: "Polygon",
    coordinates: [
      [
        [108.52140426635742, 49.12410690961098],
        [108.533935546875, 49.224772722794825],
        [108.57152938842772, 49.33116330436252],
        [108.57513427734374, 49.330492083934836],
        [108.6492919921875, 49.350177413469],
        [108.819580078125, 49.34302002289675],
        [108.929443359375, 49.350177413469],
        [109.0557861328125, 49.32154160369879],
        [109.1766357421875, 49.35733376286064],
        [109.390869140625, 49.31796095602274],
        [109.53369140625, 49.221185044221336],
        [109.75341796875, 49.22836014090129],
        [110.0994873046875, 49.18170338770663],
        [110.22033691406249, 49.15296965617039],
        [110.3411865234375, 49.2140089056539],
        [110.3851318359375, 49.25346477497736],
        [110.5938720703125, 49.1888842152458],
        [110.7861328125, 49.17452151806784],
        [111.082763671875, 49.27138884351881],
        [111.2860107421875, 49.30721745093609],
        [111.39038085937499, 49.35733376286064],
        [111.53869628906249, 49.32154160369879],
        [111.68701171875, 49.38594874941847],
        [111.78039550781249, 49.38952445158216],
        [111.939697265625, 49.37522008143603],
        [111.99600219726562, 49.392206057422044],
        [111.99600219726562, 49.392206057422044],
        [112.08114624023438, 49.359122687528746],
        [112.15393066406249, 49.32064646618636],
        [112.16629028320312, 49.30184481970431],
        [112.18551635742186, 49.2202880838794],
        [112.19375610351562, 49.14039340493346],
        [112.2198486328125, 49.081062364320736],
        [112.26654052734375, 49.034266715880854],
        [112.291259765625, 48.9991410647952],
        [112.28851318359375, 48.963089005540155],
        [112.23907470703124, 48.89000369970676],
        [112.23907470703124, 48.83941303819501],
        [112.2967529296875, 48.741700879765396],
        [112.48077392578124, 48.5147849720974],
        [112.5164794921875, 48.47838371535879],
        [112.54119873046875, 48.39456162202509],
        [112.5164794921875, 48.32156041109599],
        [112.510986328125, 48.24113823848045],
        [112.54119873046875, 48.0762438718672],
        [112.60986328125, 47.929226038300406],
        [112.69432067871094, 47.79378398661931],
        [112.68402099609374, 47.79286140021344],
        [112.5494384765625, 47.79286140021344],
        [112.39562988281249, 47.76148371616669],
        [112.2802734375, 47.711609647845975],
        [112.1484375, 47.667237034505156],
        [112.0770263671875, 47.60986653003798],
        [112.049560546875, 47.49864785970502],
        [112.04887390136719, 47.381614160856806],
        [112.06535339355469, 47.31648293428332],
        [111.796875, 47.37975438400816],
        [111.67053222656249, 47.32951560950956],
        [111.54693603515625, 47.253135632244216],
        [111.46453857421875, 47.133687832776076],
        [111.434326171875, 47.023333688184934],
        [111.42059326171874, 46.96713374957251],
        [111.3848876953125, 46.90899838277448],
        [111.37939453125, 46.854556538855746],
        [111.39038085937499, 46.79253827035979],
        [111.29974365234375, 46.73233101286786],
        [111.24481201171875, 46.66074749832071],
        [111.22558593749999, 46.57585481240773],
        [111.24755859375, 46.49082901981415],
        [111.26129150390625, 46.43217825300941],
        [111.2200927734375, 46.32417161725694],
        [111.16687774658203, 46.23139052104091],
        [111.1651611328125, 46.23685258143992],
        [111.05529785156249, 46.15700496290803],
        [110.950927734375, 46.06560846138691],
        [110.5609130859375, 46.0998999106273],
        [110.511474609375, 46.229253045075275],
        [110.379638671875, 46.384833223492784],
        [110.2093505859375, 46.51351558059737],
        [110.12695312499999, 46.604167162931844],
        [110.0225830078125, 46.63057868059483],
        [109.97863769531249, 46.60039303734547],
        [110.0115966796875, 46.46056554578543],
        [109.9346923828125, 46.33934333161126],
        [109.8797607421875, 46.26724020382508],
        [109.6160888671875, 46.14939437647686],
        [109.5172119140625, 46.16841886922939],
        [109.324951171875, 46.16841886922939],
        [109.21508789062499, 46.22545288226939],
        [109.149169921875, 46.29001987172955],
        [109.12170410156249, 46.37725420510028],
        [108.95828247070312, 46.464349400461124],
        [108.95862579345703, 46.463876433008494],
        [108.9788818359375, 46.50406399740093],
        [108.9678955078125, 46.60228013300284],
        [108.96514892578124, 46.68147880091785],
        [108.99810791015625, 46.779373682055635],
        [109.00634765625, 46.81509864599243],
        [108.9788818359375, 46.83389173208538],
        [108.91571044921875, 46.856434763486966],
        [108.88275146484375, 46.922131240914],
        [108.82232666015625, 46.98399993718925],
        [108.82095336914062, 46.98118927533914],
        [108.7261962890625, 47.02146130911727],
        [108.643798828125, 47.10378387099161],
        [108.599853515625, 47.22329888685773],
        [108.5394287109375, 47.26432008025478],
        [108.5064697265625, 47.349989032003215],
        [108.3526611328125, 47.56448075401425],
        [108.35163116455078, 47.56355410390809],
        [108.40072631835938, 47.632081940263305],
        [108.42544555664062, 47.676253276991204],
        [108.44192504882812, 47.716922585179084],
        [108.4457015991211, 47.7483271435476],
        [108.43677520751953, 47.805084340797606],
        [108.4357452392578, 47.83597479903542],
        [108.43883514404297, 47.86523461231467],
        [108.45325469970703, 47.90483575868255],
        [108.45222473144531, 47.90483575868255],
        [108.54595184326172, 47.92209422156047],
        [108.6712646484375, 47.96050238891509],
        [108.775634765625, 48.028509034432986],
        [108.8909912109375, 48.08358376568458],
        [108.929443359375, 48.17524408990215],
        [108.96240234375, 48.21735290928554],
        [109.00360107421874, 48.23930899024905],
        [109.04205322265625, 48.32156041109599],
        [109.017333984375, 48.40732607972984],
        [108.95965576171875, 48.525700252688765],
        [108.91845703124999, 48.66557095325139],
        [108.87451171875, 48.74713432542004],
        [108.8580322265625, 48.80686346108517],
        [108.7481689453125, 48.963990624864145],
        [108.52088928222655, 49.124668601968175],
        [108.52140426635742, 49.12410690961098],
      ],
    ],
  },
};
